export { C as CUSTOM_NO_COMPONENT, D as DEVELOPMENT_MODE, h as EMPTY_CONTAINER_STYLE_ANGULAR, f as EMPTY_CONTAINER_STYLE_REACT, E as END_CLASS, P as PRODUCTION_MODE, S as START_CLASS, _ as __UVE_EVENTS__, d as __UVE_EVENT_ERROR_FALLBACK__, q as combineClasses, p as computeScrollIsInBottom, n as findDotCMSElement, o as findDotCMSVTLData, m as getClosestDotCMSContainerData, t as getColumnPositionClasses, w as getContainersData, x as getContentletsInContainer, l as getDotCMSContainerData, k as getDotCMSContentletsBound, j as getDotCMSPageBounds, y as getDotContainerAttributes, v as getDotContentletAttributes, A as isValidBlocks, z as setBounds } from './public.esm.js';
import '@dotcms/types';
import '@dotcms/types/internal';

/**
 * TinyMCE default config across all versions
 *
 * @internal
 */
const __DEFAULT_TINYMCE_CONFIG__ = {
  menubar: false,
  inline: true,
  valid_styles: {
    '*': 'font-size,font-family,color,text-decoration,text-align'
  },
  powerpaste_word_import: 'clean',
  powerpaste_html_import: 'clean',
  suffix: '.min' // Suffix to use when loading resources
};
/**
 * TinyMCE config to use per mode
 *
 * @internal
 */
const __BASE_TINYMCE_CONFIG_WITH_NO_DEFAULT__ = {
  full: {
    plugins: 'link lists autolink charmap',
    toolbar: ['styleselect undo redo | bold italic underline | forecolor backcolor | alignleft aligncenter alignright alignfull | numlist bullist outdent indent | hr charmap removeformat | link'],
    style_formats: [{
      title: 'Paragraph',
      format: 'p'
    }, {
      title: 'Header 1',
      format: 'h1'
    }, {
      title: 'Header 2',
      format: 'h2'
    }, {
      title: 'Header 3',
      format: 'h3'
    }, {
      title: 'Header 4',
      format: 'h4'
    }, {
      title: 'Header 5',
      format: 'h5'
    }, {
      title: 'Header 6',
      format: 'h6'
    }, {
      title: 'Pre',
      format: 'pre'
    }, {
      title: 'Code',
      format: 'code'
    }]
  },
  plain: {
    plugins: '',
    toolbar: ''
  },
  minimal: {
    plugins: 'link autolink',
    toolbar: 'bold italic underline | link',
    valid_elements: 'strong,em,span[style],a[href]'
  }
};
/**
 * TinyMCE path
 *
 * @internal
 */
const __TINYMCE_PATH_ON_DOTCMS__ = '/ext/tinymcev7/tinymce.min.js';

export { __BASE_TINYMCE_CONFIG_WITH_NO_DEFAULT__, __DEFAULT_TINYMCE_CONFIG__, __TINYMCE_PATH_ON_DOTCMS__ };
